export default __webpack_public_path__ + "static/media/browser.d84764d6.svg";